'use client';

import React, { type ForwardedRef, type ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type FilterSettingsDesktopButtonProps = {
  /** Filter that should be rendered within the popover */
  children: ReactNode;
  isActive?: boolean;
  isPopoverOpen?: boolean;
  onClick?: () => void;
  large?: boolean;
};

const messages = defineMessages({
  activeFilter: {
    id: 'search.filters.desktop.activeIcon',
    defaultMessage: ', active filter',
  },
  inactiveFilter: {
    id: 'search.filters.desktop.inactiveIcon',
    defaultMessage: ', filter', // NOTE: name for rating values is usually just "& mehr" or something similar
  },
});

export const FilterSettingsDesktopButton = React.forwardRef(
  (
    { children, isActive, isPopoverOpen, onClick, large }: FilterSettingsDesktopButtonProps,
    ref?: ForwardedRef<HTMLButtonElement | null>,
  ) => {
    const { formatMessage } = useIntl();

    const icon = isActive ? (
      <span
        className="icon-emp-checkmark size-4"
        aria-label={formatMessage(messages.activeFilter)}
      />
    ) : (
      <span
        className="icon-emp-arrow-medium-down size-4"
        aria-label={formatMessage(messages.inactiveFilter)}
      />
    );

    return (
      <Button
        className={`flex w-full pr-1 ${large ? 'h-[2.75rem]' : 'h-[2.25rem]'}`}
        onClick={onClick}
        ref={ref}
      >
        <div className="mr-auto w-full overflow-hidden text-left leading-normal hyphens-auto">
          {children}
        </div>
        {isPopoverOpen ? <span className="icon-emp-cancel size-4" /> : icon}
      </Button>
    );
  },
);
